(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["packsys-bolsas-volume"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('packsys-bolsas-volume')) return;
  const tiers = [100, 500, 1000, 2000, 5000, 10000].map(quantity => ({ quantity }));
  const discountRules = {"22 x 30 cm": [{"minimum": 62000, "percent": 7, "title": "Bolsas envío 22 x 30 cm · 7% desde 400"}, {"minimum": 124000, "percent": 11, "title": "Bolsas envío 22 x 30 cm · 11% desde 800"}, {"minimum": 248000, "percent": 15, "title": "Bolsas envío 22 x 30 cm · 15% desde 1600"}, {"minimum": 496000, "percent": 18, "title": "Bolsas envío 22 x 30 cm · 18% desde 3200"}, {"minimum": 992000, "percent": 20, "title": "Bolsas envío 22 x 30 cm · 20% desde 6400"}], "28 x 35 cm": [{"minimum": 72000, "percent": 7, "title": "Bolsas envío 28 x 35 cm · 7% desde 400"}, {"minimum": 144000, "percent": 11, "title": "Bolsas envío 28 x 35 cm · 11% desde 800"}, {"minimum": 288000, "percent": 15, "title": "Bolsas envío 28 x 35 cm · 15% desde 1600"}, {"minimum": 576000, "percent": 18, "title": "Bolsas envío 28 x 35 cm · 18% desde 3200"}, {"minimum": 1152000, "percent": 20, "title": "Bolsas envío 28 x 35 cm · 20% desde 6400"}], "38 x 48 cm": [{"minimum": 107200, "percent": 7, "title": "Bolsas envío 38 x 48 cm · 7% desde 400"}, {"minimum": 214400, "percent": 11, "title": "Bolsas envío 38 x 48 cm · 11% desde 800"}, {"minimum": 428800, "percent": 15, "title": "Bolsas envío 38 x 48 cm · 15% desde 1600"}, {"minimum": 857600, "percent": 18, "title": "Bolsas envío 38 x 48 cm · 18% desde 3200"}, {"minimum": 1715200, "percent": 20, "title": "Bolsas envío 38 x 48 cm · 20% desde 6400"}], "13 x 26 cm": [{"minimum": 33600, "percent": 7, "title": "Bolsas envío 13 x 26 cm · 7% desde 400"}, {"minimum": 67200, "percent": 11, "title": "Bolsas envío 13 x 26 cm · 11% desde 800"}, {"minimum": 134400, "percent": 15, "title": "Bolsas envío 13 x 26 cm · 15% desde 1600"}]};
  const normalize = value => Math.min(1000000, Math.max(100, Math.ceil((Number(value) || 100) / 100) * 100));
  function allocation(variants, quantity, cartItems = [], rules = [], cartSubtotal = 0) {
    const units = quantity / 100;
    if (!Number.isSafeInteger(units) || units < 1 || quantity > 1000000) return null;
    const small = variants.find(v => v.pack === 100);
    const large = variants.find(v => v.pack === 500);
    const capacity = variant => {
      if (!variant?.available) return 0;
      const used = cartItems.filter(item => Number(item.variant_id) === variant.id).reduce((n, item) => n + item.quantity, 0);
      return variant.tracked ? Math.max(0, variant.stock - used) : units;
    };
    const smallMax = capacity(small);
    const largeMax = Math.min(Math.floor(units / 5), capacity(large));
    let best = null;
    let bestTotal = Infinity;
    for (let largeCount = largeMax; largeCount >= 0; largeCount--) {
      const smallCount = units - largeCount * 5;
      if (smallCount > smallMax) continue;
      const plan = [];
      if (largeCount) plan.push({ variant: large, quantity: largeCount });
      if (smallCount) plan.push({ variant: small, quantity: smallCount });
      const subtotal = plan.reduce((sum, item) => sum + item.variant.price * item.quantity, 0);
      const percent = [...rules].reverse().find(rule => cartSubtotal + subtotal >= rule.minimum)?.percent || 0;
      const total = plan.reduce((sum, item) => {
        const line = item.variant.price * item.quantity;
        return sum + line - Math.round(line * percent / 100);
      }, 0);
      if (total < bestTotal) { best = plan; bestTotal = total; }
    }
    return best;
  }

  class PacksysBolsasVolume extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        this.form?.addEventListener('submit', this.onSubmit, true);
        this.scope?.classList.add('ps-volume-ready');
        return;
      }
      this.config = JSON.parse(this.querySelector('[data-config]').textContent);
      const baseVariants = this.config.variants.filter(variant => variant.pack === 100);
      const validVariants = baseVariants.length > 0 && baseVariants.every(variant => Number.isSafeInteger(variant.price) && variant.price >= 0);
      if (!validVariants) return;
      this.form = this.closest('form');
      this.scope = this.closest('.product__info-container');
      if (!this.form || !this.scope) return;
      this.initialized = true;
      this.strings = this.config.strings;
      this.quantity = normalize(100);
      const selected = this.config.variants.find(v => v.id === this.config.selectedVariant);
      this.size = selected?.size || '22 x 30 cm';
      if (selected) this.quantity = selected.pack;
      this.cart = { items: [], currency: 'MXN' };
      this.busy = false;
      this.cartReady = false;
      this.blocked = this.dataset.blocked === 'true';
      this.number = new Intl.NumberFormat('es-MX');
      this.money = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', currencyDisplay: 'narrowSymbol', minimumFractionDigits: 2, maximumFractionDigits: 2 });
      this.root = window.Shopify?.routes?.root || '/';
      this.onSubmit = event => { event.preventDefault(); event.stopImmediatePropagation(); this.add(); };
      this.form.addEventListener('submit', this.onSubmit, true);
      const addButton = this.querySelector('[data-add]');
      if (addButton) addButton.type = 'submit';
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || this.busy || button.disabled) return;
        this.querySelector('[data-status]').hidden = true;
        if (button.dataset.size) this.selectSize(button.dataset.size);
        if (button.dataset.step) this.quantity = normalize(this.quantity + Number(button.dataset.step));
        if (button.dataset.preset) this.quantity = Number(button.dataset.preset);
        if (button.type !== 'submit') this.render();
      });
      this.querySelector('[data-quantity]').addEventListener('input', event => { this.quantity = Number(event.target.value); this.render(true); });
      this.buildTiers();
      this.selectSize(this.size);
      this.hidden = false;
      this.scope.classList.add('ps-volume-ready');
      this.render();
      this.refreshCart().then(() => this.render()).catch(() => this.showError(this.strings.cart_error));
    }
    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.onSubmit, true);
      this.scope?.classList.remove('ps-volume-ready');
    }
    text(key, values = {}) {
      return Object.entries(values).reduce((result, [name, value]) => result.replaceAll(`{${name}}`, String(value)), this.strings[key] || key);
    }
    price(cents) { return this.money.format(cents / 100); }
    buildTiers() {
      tiers.forEach((tier, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.preset = String(tier.quantity);
        button.setAttribute('aria-pressed', 'false');
        const label = document.createElement('span');
        label.textContent = this.text('bags', { quantity: this.number.format(tier.quantity) });
        button.append(label);
        this.querySelector(index < 4 ? '[data-primary-tiers]' : '[data-extra-tiers]').append(button);
      });
    }
    selectSize(size) {
      this.size = size;
      const variant = this.config.variants.find(v => v.size === size && v.pack === 100);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(variant.id));
      window.history.replaceState({}, '', url);
      this.form.querySelector('[name="id"]').value = String(variant.id);
      this.dispatchEvent(new CustomEvent('packsys:bags-size-change', { bubbles: true, detail: { variantId: variant.id } }));
      const picker = this.scope.querySelector('pickup-availability');
      if (picker?.fetchAvailability) picker.fetchAvailability(variant.id);
    }
    sizeVariants() { return this.config.variants.filter(v => v.size === this.size); }
    inCart() {
      return this.cart.items.reduce((count, item) => {
        const variant = this.sizeVariants().find(v => v.id === Number(item.variant_id));
        return count + (variant ? item.quantity * variant.pack : 0);
      }, 0);
    }
    async refreshCart() {
      const response = await fetch(`${this.root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error(this.strings.cart_error);
      const cart = await response.json();
      if (!Array.isArray(cart.items)) throw new Error(this.strings.cart_error);
      this.cart = cart;
      this.cartReady = true;
    }
    subtotalInCart() {
      const ids = new Set(this.sizeVariants().map(v => v.id));
      return this.cart.items.filter(item => ids.has(Number(item.variant_id))).reduce((sum, item) => {
        const variant = this.sizeVariants().find(v => v.id === Number(item.variant_id));
        return sum + (Number.isFinite(item.original_line_price) ? item.original_line_price : variant.price * item.quantity);
      }, 0);
    }
    quote(quantity = this.quantity) {
      const variants = this.sizeVariants();
      const rules = discountRules[this.size] || [];
      const plan = allocation(variants, quantity, this.cart.items, rules, this.subtotalInCart());
      const base = variants.find(v => v.pack === 100)?.price;
      const configured = Number.isSafeInteger(base) && base >= 0;
      const undiscounted = plan ? plan.reduce((sum, item) => sum + item.variant.price * item.quantity, 0) : null;
      const subtotal = this.subtotalInCart() + (undiscounted || 0);
      const tier = [...rules].reverse().find(rule => subtotal >= rule.minimum) || { minimum: 0, percent: 0 };
      const total = undiscounted == null ? null : plan.reduce((sum, item) => {
        const line = item.variant.price * item.quantity;
        return sum + line - Math.round(line * tier.percent / 100);
      }, 0);
      return { plan, tier, base, configured, undiscounted, total, subtotal, rules };
    }
    render(preserveInput = false) {
      const quote = this.quote();
      const count = this.inCart();
      const validQuantity = Number.isSafeInteger(this.quantity) && this.quantity >= 100 && this.quantity <= 1000000 && this.quantity % 100 === 0;
      if (!preserveInput) this.querySelector('[data-quantity]').value = String(this.quantity);
      this.querySelector('[data-quantity]').disabled = this.busy;
      this.querySelector('[data-quantity]').setAttribute('aria-invalid', String(!validQuantity));
      this.querySelectorAll('[data-size]').forEach(button => { button.disabled = this.busy; });
      this.querySelector('[data-step="-100"]').disabled = this.quantity <= 100 || this.busy;
      this.querySelector('[data-step="100"]').disabled = this.quantity >= 1000000 || this.busy;
      this.querySelectorAll('[data-size]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.size === this.size)));
      this.querySelectorAll('[data-preset]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.preset) === this.quantity)));
      this.querySelector('[data-tiers]').hidden = !quote.base;
      this.querySelector('[data-legacy]').hidden = Boolean(quote.base);
      this.querySelector('.ps-volume__more').hidden = false;
      const next = quote.rules.find(rule => rule.minimum > quote.subtotal);
      this.querySelector('[data-next]').textContent = !validQuantity ? this.strings.invalid : !quote.plan ? this.strings.stock : next ? this.text('next_amount', { price: this.price(next.minimum - quote.subtotal), percent: next.percent }) : quote.rules.length ? this.text('maximum', { percent: quote.tier.percent }) : '';
      const progress = quote.plan ? (next ? Math.min(100, Math.max(0, quote.subtotal / next.minimum * 100)) : quote.rules.length ? 100 : 0) : 0;
      this.querySelector('[data-progress-fill]').style.width = progress + '%';
      const track = this.querySelector('.ps-volume__track');
      track.setAttribute('aria-valuenow', String(Math.round(progress)));
      track.setAttribute('aria-valuetext', this.querySelector('[data-next]').textContent);
      this.querySelector('.ps-volume__basis').textContent = this.strings.basis;
      this.querySelector('[data-progress]').hidden = false;
      this.querySelectorAll('[data-preset]').forEach(button => {
        const preset = this.quote(Number(button.dataset.preset));
        let badge = button.querySelector('.ps-volume__badge');
        if (!badge) { badge = document.createElement('span'); badge.className = 'ps-volume__badge'; button.append(badge); }
        badge.textContent = preset.plan ? (preset.tier.percent ? this.text('save', { percent: preset.tier.percent }) : this.strings.no_discount) : this.strings.sold_out;
        badge.hidden = false;
        let amount = button.querySelector('[data-preset-price]');
        if (!amount) { amount = document.createElement('span'); amount.dataset.presetPrice = ''; button.append(amount); }
        amount.textContent = preset.total == null ? '' : this.price(preset.total);
        let selectedLabel = button.querySelector('[data-selected-label]');
        if (!selectedLabel) { selectedLabel = document.createElement('span'); selectedLabel.dataset.selectedLabel = ''; button.append(selectedLabel); }
        selectedLabel.textContent = this.strings.selected;
        selectedLabel.hidden = false;
        const selectedPreset = Number(button.dataset.preset) === this.quantity;
        selectedLabel.style.visibility = selectedPreset ? 'visible' : 'hidden';
        selectedLabel.setAttribute('aria-hidden', String(!selectedPreset));
        button.disabled = this.busy || !preset.plan;
      });
      this.querySelector('[data-cart-count]').hidden = count === 0;
      this.querySelector('[data-cart-count]').textContent = this.text('cart_count', { quantity: this.number.format(count) });
      this.querySelector('[data-total-bags]').textContent = validQuantity ? this.text('bags', { quantity: this.number.format(this.quantity) }) : '—';
      this.querySelector('[data-packs]').textContent = quote.plan ? quote.plan.map(item => this.text('pack_line', { quantity: item.quantity, pack: item.variant.pack })).join(' + ') : '';
      const pickupSelection = this.scope.querySelector('[data-pickup-selection]');
      if (pickupSelection) pickupSelection.textContent = quote.plan ? `${this.size} · ${this.text('bags', { quantity: this.number.format(this.quantity) })} · ${this.querySelector('[data-packs]').textContent}` : '—';
      this.querySelector('[data-total]').textContent = quote.total == null ? '—' : `${this.price(quote.total)} MXN`;
      this.querySelector('[data-unit]').textContent = quote.total == null ? this.strings.unavailable : this.text('per_bag', { price: new Intl.NumberFormat('es-MX', {style: 'currency', currency: 'MXN', minimumFractionDigits: 3, maximumFractionDigits: 3}).format(quote.total / this.quantity / 100) });
      this.querySelector('[data-saving]').hidden = false;
      this.querySelector('[data-saving]').dataset.state = !quote.plan ? 'pending' : quote.tier.percent ? 'active' : 'none';
      this.querySelector('[data-saving]').textContent = this.text('saving', { price: quote.plan ? this.price(quote.undiscounted - quote.total) : '—', percent: quote.plan ? quote.tier.percent : '—' });
      const currencyOk = this.cart.currency === 'MXN';
      const button = this.querySelector('[data-add]');
      if (button) {
        button.disabled = this.busy || !this.cartReady || !quote.plan || !quote.configured || !currencyOk;
        button.textContent = this.busy ? this.strings.adding : this.strings.add;
      }
      let error = !validQuantity ? this.strings.invalid : !currencyOk ? this.strings.currency : !quote.configured ? this.strings.configuration : !quote.plan ? this.strings.stock : '';
      this.showError(error);
      this.setAttribute('aria-busy', String(this.busy));
    }
    showError(message) {
      this.querySelector('[data-error]').textContent = message;
      this.querySelector('[data-error]').hidden = !message;
    }
    async add() {
      if (this.busy || this.blocked) return;
      this.quantity = Number(this.querySelector('[data-quantity]').value);
      if (!Number.isSafeInteger(this.quantity) || this.quantity < 100 || this.quantity > 1000000 || this.quantity % 100 !== 0) { this.render(true); return; }
      this.busy = true;
      this.render();
      let sent = false;
      try {
        await this.refreshCart();
        const quote = this.quote();
        if (this.cart.currency !== 'MXN') throw new Error(this.strings.currency);
        if (!quote.configured) throw new Error(this.strings.configuration);
        if (!quote.plan) throw new Error(this.strings.stock);
        const attributes = {};
        new FormData(this.form).forEach((value, key) => {
          const match = key.match(/^attributes\[(.+)\]$/);
          if (match) attributes[match[1]] = value;
        });
        if (Object.keys(attributes).length) {
          const result = await fetch(`${this.root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes }) });
          if (!result.ok) throw new Error(this.strings.error);
        }
        const notification = document.querySelector('cart-notification');
        const payload = { items: quote.plan.map(item => ({ id: item.variant.id, quantity: item.quantity })) };
        if (notification && payload.items.length === 1) {
          payload.sections = notification.getSectionsToRender().map(section => section.id);
          payload.sections_url = window.location.pathname;
          notification.setActiveElement(document.activeElement);
        }
        sent = true;
        const response = await fetch(`${this.root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || this.strings.error);
        if (notification && payload.items.length === 1 && result.sections && Object.values(result.sections).every(Boolean)) {
          try { notification.renderContents({ ...result, key: result.items[0].key }); } catch (_) { window.location.assign(`${this.root}cart`); return; }
          await this.refreshCart();
          this.querySelector('[data-status]').textContent = this.text('added', { quantity: this.number.format(this.quantity) });
          this.querySelector('[data-status]').hidden = false;
          this.querySelector('[data-cart-link]').hidden = false;
        } else {
          window.location.assign(`${this.root}cart`);
          return;
        }
      } catch (error) {
        this.busy = false;
        this.render();
        this.showError(sent ? `${error.message || this.strings.error} ${this.strings.error}` : error.message || this.strings.cart_error);
        if (sent) this.querySelector('[data-cart-link]').hidden = false;
        return;
      }
      this.busy = false;
      this.render();
    }
  }
  customElements.define('packsys-bolsas-volume', PacksysBolsasVolume);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["packsys-lentes-volume"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('packsys-lentes-volume')) return;
  const tiers = [1, 5, 10, 15].map(quantity => ({ quantity }));
  const discountRules = [{ minimum: 5, percent: 5 }, { minimum: 10, percent: 7 }, { minimum: 15, percent: 10 }];
  const normalize = value => Math.min(1000000, Math.max(1, Math.ceil(Number(value) || 1)));
  function allocation(variants, quantity, cartItems = []) {
    const units = quantity;
    const small = variants.find(v => v.pack === 1);
    if (!Number.isSafeInteger(units) || units < 1 || !small?.available) return null;
    const used = cartItems.filter(item => Number(item.variant_id) === small.id).reduce((n, item) => n + item.quantity, 0);
    if (small.tracked && units > Math.max(0, small.stock - used)) return null;
    return [{ variant: small, quantity: units }];
  }

  class PacksysLentesVolume extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        this.form?.addEventListener('submit', this.onSubmit, true);
        this.scope?.classList.add('ps-lentes-ready');
        return;
      }
      this.config = JSON.parse(this.querySelector('[data-config]').textContent);
      const baseVariants = this.config.variants.filter(variant => variant.pack === 1);
      const validVariants = baseVariants.length > 0 && baseVariants.every(variant => Number.isSafeInteger(variant.price) && variant.price >= 0);
      if (!validVariants) return;
      this.scope = this.closest('.product__info-container');
      this.form = this.scope?.querySelector('form[data-type="add-to-cart-form"]');
      if (!this.form || !this.scope) return;
      this.scope.querySelectorAll('variant-radios, variant-selects, .product-form__quantity, .product-form__buttons, .product__tax, .installment, [id^="price-"]').forEach(element => element.setAttribute('data-ps-lentes-native', ''));
      this.initialized = true;
      this.strings = this.config.strings;
      this.quantity = normalize(1);
      const selected = this.config.variants.find(v => v.id === this.config.selectedVariant);
      this.size = selected?.size || this.config.variants.find(v => v.pack === 1)?.size;
      if (selected) this.quantity = normalize(selected.pack);
      this.cart = { items: [], currency: 'MXN' };
      this.busy = false;
      this.cartReady = false;
      this.blocked = this.dataset.blocked === 'true';
      this.number = new Intl.NumberFormat('es-MX');
      this.money = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', currencyDisplay: 'narrowSymbol', minimumFractionDigits: 2, maximumFractionDigits: 2 });
      this.root = window.Shopify?.routes?.root || '/';
      this.onSubmit = event => { event.preventDefault(); event.stopImmediatePropagation(); this.add(); };
      this.form.addEventListener('submit', this.onSubmit, true);
      const addButton = this.querySelector('[data-add]');
      if (addButton) { addButton.type = 'submit'; addButton.setAttribute('form', this.form.getAttribute('id')); }
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || this.busy) return;
        if (button.dataset.size) this.selectSize(button.dataset.size);
        if (button.dataset.step) this.quantity = normalize(this.quantity + Number(button.dataset.step));
        if (button.dataset.preset) this.quantity = Number(button.dataset.preset);
        if (button.type !== 'submit') this.render();
      });
      this.querySelector('[data-quantity]').addEventListener('change', event => { this.quantity = normalize(event.target.value); this.render(); });
      this.querySelectorAll('[data-size]').forEach(button => {
        button.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') this.previewSize(button.dataset.size);
        });
        button.addEventListener('pointerleave', () => this.previewSize(this.size));
        button.addEventListener('focus', () => this.previewSize(button.dataset.size));
        button.addEventListener('blur', () => this.previewSize(this.size));
      });
      this.buildTiers();
      this.selectSize(this.size);
      this.hidden = false;
      this.scope.classList.add('ps-lentes-ready');
      this.render();
      this.refreshCart().then(() => this.render()).catch(() => this.showError(this.strings.cart_error));
    }
    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.onSubmit, true);
      this.scope?.classList.remove('ps-lentes-ready');
    }
    text(key, values = {}) {
      return Object.entries(values).reduce((result, [name, value]) => result.replaceAll(`{${name}}`, String(value)), this.strings[key] || key);
    }
    price(cents) { return this.money.format(cents / 100); }
    buildTiers() {
      tiers.forEach((tier, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.preset = String(tier.quantity);
        button.setAttribute('aria-pressed', 'false');
        const label = document.createElement('span');
        label.textContent = this.text('bags', { quantity: this.number.format(tier.quantity) });
        button.append(label);
        this.querySelector(index < 4 ? '[data-primary-tiers]' : '[data-extra-tiers]').append(button);
      });
    }
    previewSize(size) {
      const variant = this.config.variants.find(v => v.size === size && v.pack === 1);
      const gallery = document.getElementById('MediaGallery-' + this.dataset.section)?.querySelector('.product__image-slider');
      const carousel = gallery && window.Flickity?.data(gallery);
      if (!variant?.mediaId || !carousel) return;
      const index = Array.from(gallery.querySelectorAll('.carousel-cell')).findIndex(cell =>
        cell.querySelector('img')?.dataset.mediaId === String(variant.mediaId)
      );
      if (index >= 0) carousel.select(index, false, true);
    }
    selectSize(size) {
      this.size = size;
      const variant = this.config.variants.find(v => v.size === size && v.pack === 1);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(variant.id));
      window.history.replaceState({}, '', url);
      this.form.querySelector('[name="id"]').value = String(variant.id);
      const picker = this.scope.querySelector('pickup-availability');
      if (picker?.fetchAvailability) picker.fetchAvailability(variant.id);
      this.previewSize(size);
    }
    sizeVariants() { return this.config.variants.filter(v => v.size === this.size); }
    inCart() {
      return this.cart.items.reduce((count, item) => {
        const variant = this.sizeVariants().find(v => v.id === Number(item.variant_id));
        return count + (variant ? item.quantity * variant.pack : 0);
      }, 0);
    }
    async refreshCart() {
      const response = await fetch(`${this.root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error(this.strings.cart_error);
      const cart = await response.json();
      if (!Array.isArray(cart.items)) throw new Error(this.strings.cart_error);
      this.cart = cart;
      this.cartReady = true;
    }
    eligibleCount() {
      const ids = new Set(this.config.variants.filter(v => v.pack === 1).map(v => v.id));
      return this.cart.items.filter(item => ids.has(Number(item.variant_id))).reduce((n, item) => n + item.quantity, 0);
    }
    subtotalInCart() {
      const ids = new Set(this.sizeVariants().map(v => v.id));
      return this.cart.items.filter(item => ids.has(Number(item.variant_id))).reduce((sum, item) => {
        const variant = this.sizeVariants().find(v => v.id === Number(item.variant_id));
        return sum + (Number.isFinite(item.original_line_price) ? item.original_line_price : variant.price * item.quantity);
      }, 0);
    }
    quote(quantity = this.quantity) {
      const variants = this.sizeVariants();
      const plan = allocation(variants, quantity, this.cart.items);
      const base = variants.find(v => v.pack === 1)?.price;
      const configured = Number.isSafeInteger(base) && base >= 0;
      const undiscounted = plan ? plan.reduce((sum, item) => sum + item.variant.price * item.quantity, 0) : null;
      const subtotal = this.subtotalInCart() + (undiscounted || 0);
      const rules = this.config.discountsVerified ? discountRules : [];
      const tier = [...rules].reverse().find(rule => this.eligibleCount() + quantity >= rule.minimum) || { minimum: 0, percent: 0 };
      const total = undiscounted == null ? null : plan.reduce((sum, item) => {
        const unit = Math.round(item.variant.price * (100 - tier.percent) / 100);
        return sum + unit * item.quantity;
      }, 0);
      return { plan, tier, base, configured, undiscounted, total, subtotal, rules };
    }
    render() {
      const quote = this.quote();
      const count = this.inCart();
      const combined = this.quantity + count;
      this.querySelector('[data-quantity]').value = String(this.quantity);
      this.querySelector('[data-step="-1"]').disabled = this.quantity <= 1 || this.busy;
      this.querySelector('[data-step="1"]').disabled = this.quantity >= 1000000 || this.busy;
      this.querySelectorAll('[data-size]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.size === this.size)));
      const activeMinimum = this.config.discountsVerified ? (quote.tier.minimum || 1) : ([...tiers].reverse().find(tier => this.quantity >= tier.quantity)?.quantity || 1);
      this.querySelectorAll('[data-preset]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.preset) === activeMinimum)));
      this.querySelector('[data-tiers]').hidden = !quote.base;
      this.querySelector('[data-legacy]').hidden = Boolean(quote.base);
      this.querySelector('.ps-lentes__more').hidden = true;
      const totalPieces = this.eligibleCount() + this.quantity;
      const next = quote.rules.find(rule => rule.minimum > totalPieces);
      this.querySelector('[data-next]').textContent = next ? this.text('next', {quantity: this.number.format(next.minimum - totalPieces), percent: next.percent}) : quote.rules.length ? this.text('maximum', {percent: quote.tier.percent}) : '';
      this.querySelector('[data-tier-active]').textContent = quote.tier.percent ? this.text('active_discount', {percent: quote.tier.percent}) : '';
      this.querySelector('[data-tier-active]').hidden = !quote.tier.percent;
      const previous = quote.tier.minimum;
      this.querySelector('[data-progress-fill]').style.width = `${next ? Math.min(100, Math.max(0, (totalPieces - previous) / (next.minimum - previous)) * 100) : 100}%`;
      this.querySelector('.ps-lentes__basis').hidden = !this.config.discountsVerified;
      this.querySelector('[data-progress]').hidden = !this.config.discountsVerified;
      this.querySelectorAll('[data-preset]').forEach(button => {
        const preset = this.quote(Number(button.dataset.preset));
        let badge = button.querySelector('.ps-lentes__badge');
        if (!badge) { badge = document.createElement('span'); badge.className = 'ps-lentes__badge'; button.append(badge); }
        const presetTier = this.config.discountsVerified ? [...discountRules].reverse().find(rule => Number(button.dataset.preset) >= rule.minimum) : null;
        badge.textContent = presetTier ? this.text('save', {percent: presetTier.percent}) : '';
        badge.hidden = !presetTier;
        button.disabled = this.busy || !preset.plan;
      });
      this.querySelector('[data-cart-count]').hidden = count === 0;
      this.querySelector('[data-cart-count]').textContent = this.text('cart_count', { quantity: this.number.format(count) });
      this.querySelector('[data-total-bags]').textContent = this.text('bags', { quantity: this.number.format(this.quantity) });
      this.querySelector('[data-total]').textContent = quote.total == null ? '—' : `${this.price(quote.total)} MXN`;
      this.querySelector('[data-unit]').textContent = quote.total == null ? this.strings.unavailable : this.text('per_bag', { price: this.price(quote.total / this.quantity) });
      this.querySelector('[data-saving]').hidden = !quote.plan || !quote.tier.percent;
      this.querySelector('[data-saving]').textContent = this.text('saving', { price: this.price(quote.undiscounted - quote.total), percent: quote.tier.percent });
      const currencyOk = this.cart.currency === 'MXN';
      const button = this.querySelector('[data-add]');
      if (button) {
        button.disabled = this.busy || !this.cartReady || !quote.plan || !quote.configured || !currencyOk;
        button.textContent = this.busy ? this.strings.adding : this.strings.add;
      }
      let error = !currencyOk ? this.strings.currency : !quote.configured ? this.strings.configuration : !quote.plan ? this.strings.stock : '';
      this.showError(error);
      this.setAttribute('aria-busy', String(this.busy));
    }
    showError(message) {
      this.querySelector('[data-error]').textContent = message;
      this.querySelector('[data-error]').hidden = !message;
    }
    async add() {
      if (this.busy || this.blocked) return;
      this.quantity = normalize(this.querySelector('[data-quantity]').value);
      this.busy = true;
      this.render();
      let sent = false;
      try {
        await this.refreshCart();
        const quote = this.quote();
        if (this.cart.currency !== 'MXN') throw new Error(this.strings.currency);
        if (!quote.configured) throw new Error(this.strings.configuration);
        if (!quote.plan) throw new Error(this.strings.stock);
        const attributes = {};
        new FormData(this.form).forEach((value, key) => {
          const match = key.match(/^attributes\[(.+)\]$/);
          if (match) attributes[match[1]] = value;
        });
        if (Object.keys(attributes).length) {
          const result = await fetch(`${this.root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes }) });
          if (!result.ok) throw new Error(this.strings.error);
        }
        const notification = document.querySelector('cart-notification');
        const payload = { items: quote.plan.map(item => ({ id: item.variant.id, quantity: item.quantity })) };
        if (notification && payload.items.length === 1) {
          payload.sections = notification.getSectionsToRender().map(section => section.id);
          payload.sections_url = window.location.pathname;
          notification.setActiveElement(document.activeElement);
        }
        sent = true;
        const response = await fetch(`${this.root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || this.strings.error);
        if (notification && payload.items.length === 1 && result.sections && Object.values(result.sections).every(Boolean)) {
          try { notification.renderContents({ ...result, key: result.items[0].key }); } catch (_) { window.location.assign(`${this.root}cart`); return; }
          await this.refreshCart();
          this.querySelector('[data-status]').textContent = this.text('added', { quantity: this.number.format(this.quantity) });
          this.querySelector('[data-status]').hidden = false;
          this.querySelector('[data-cart-link]').hidden = false;
        } else {
          window.location.assign(`${this.root}cart`);
          return;
        }
      } catch (error) {
        this.busy = false;
        this.render();
        this.showError(sent ? `${error.message || this.strings.error} ${this.strings.error}` : error.message || this.strings.cart_error);
        if (sent) this.querySelector('[data-cart-link]').hidden = false;
        return;
      }
      this.busy = false;
      this.render();
    }
  }
  customElements.define('packsys-lentes-volume', PacksysLentesVolume);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["packsys-sobres-discounts"] && !Shopify.designMode) return;
  try {
    (() => {
  const configElement=document.getElementById('PacksysSobresDiscountConfig');
  if(!configElement||window.PacksysSobresDiscounts)return;
  const config=JSON.parse(configElement.textContent),root=config.root.replace(/\/?$/,'/');
  const filament=[{product:7622897074342,box:43799755882662,single:43796939374758,size:96,width:24},{product:7626080583846,box:43799758962854,single:43799758799014,size:48,width:48}];
  function validateFilamento(cart){
    for(const rule of filament){
      const items=cart.items.filter(i=>Number(i.product_id)===rule.product);
      const boxes=items.filter(i=>Number(i.variant_id)===rule.box).reduce((s,i)=>s+i.quantity,0);
      const other=items.filter(i=>Number(i.variant_id)!==rule.box);
      const rolls=other.reduce((s,i)=>s+i.quantity*(Number(i.variant_id)===rule.single?1:(parseInt(i.variant_title,10)||1)),0);
      if((boxes>0&&other.length)||rolls>=rule.size)throw new Error(config.filamentoMixed.replace('{width}',String(rule.width)).replace('{units}',String(rule.size)));
    }
  }
  const hasFilamento=cart=>cart.items.some(i=>filament.some(r=>Number(i.product_id)===r.product));
  const manualPairs=[[56839639433382, 56839639498918], [57597171826854, 56839639564454], [57597171859622, 56839639957670], [57597171892390, 56839640023206], [57597171925158, 56839640416422], [57597171957926, 56839638909094], [56839640875174, 56839640940710], [57597171990694, 56839640973478]];
  function stretchRule(variantId){
    const id=Number(variantId);
    const manual=manualPairs.find(pair=>pair.includes(id));
    const color=colorPairs.find(pair=>pair.includes(id));
    const pair=manual||color;
    return pair?{single:pair[0],pack:pair[1],max:3,family:manual?'manual':'color',handle:manual?'pelicula-stretch-manual':'pelicula-stretch-de-colores-paquete-de-4-rollos'}:null;
  }
  function stretchIssue(items,variantId){
    const rule=stretchRule(variantId);
    if(!rule)return null;
    const singles=items.filter(i=>Number(i.variant_id)===rule.single).reduce((n,i)=>n+Number(i.quantity),0);
    const packs=items.filter(i=>Number(i.variant_id)===rule.pack).reduce((n,i)=>n+Number(i.quantity),0);
    return singles&&packs?'mixed':singles>rule.max?'limit':null;
  }
  function validateManual(cart){
    if(manualPairs.some(pair=>stretchIssue(cart.items,pair[0])))throw new Error(config.manualMixed);
  }
  const boppIds=[57688763203750, 57688763236518, 57688763269286, 57688763302054, 57688763334822];
  const boppTiers=[[2, "BOPP-MILLARES2"], [3, "BOPP-MILLARES3"], [4, "BOPP-MILLARES4"]];
  const rules=[
    {ids:[44331147002022],tiers:[[5,"TARIMA-ONEWAY-5"],[10,"TARIMA-ONEWAY-8"],[20,"TARIMA-ONEWAY-10"]]},
    {ids:boppIds,tiers:boppTiers},
{"ids": [39489214054566, 39489214087334, 45794876719270, 45794876752038, 46052984225958, 46303846301862, 46332759736486, 46124166676646, 46124166709414], "tiers": [[3, "FLEJES-3"], [5, "FLEJES-5"], [10, "FLEJES-8"]]},{"ids": [42819546022054], "tiers": [[5, "FLEJES-G1-3"], [10, "FLEJES-G1-5"]]},{"ids": [42819546054822], "tiers": [[5, "FLEJES-G2-3"], [10, "FLEJES-G2-5"]]},{"ids": [42819390046374], "tiers": [[5, "FLEJES-G3-3"], [10, "FLEJES-G3-5"]]},
    {ids:[57608065876134],tiers:[[2,'PERRO-450-3'],[3,'PERRO-450-7']]},
    {ids:[57608066039974],tiers:[[2,'PERRO-1350-3'],[3,'PERRO-1350-7']]},
    {"ids": [57598974001318, 57598977212582, 57598977376422, 57598977671334, 57598977802406, 57598977966246, 57598978097318, 57598978228390, 57598978490534], "tiers": [[3, "VASOS-PAPEL-3-3"], [5, "VASOS-PAPEL-5-5"], [10, "VASOS-PAPEL-10-8"]]},
    {ids:[56839639498918, 56839639564454, 56839639957670, 56839640023206, 56839640416422, 56839638909094, 56839640940710, 56839640973478],tiers:[[3,'MANUAL-TRAD-3-3'],[5,'MANUAL-TRAD-5-5'],[10,'MANUAL-TRAD-10-8']]},
    {ids:[42738713690278],tiers:[[3,'MANUAL-STIFF-3-3'],[5,'MANUAL-STIFF-5-5'],[10,'MANUAL-STIFF-10-8']]},
    {ids:[42738696618150,57585232052390,57585232085158],tiers:[[2,'STRETCH-AR-2-5'],[4,'STRETCH-AR-4-8']]},
    {ids:[43799755882662,43799758962854],tiers:[[3,'FILAMENTO-3'],[5,'FILAMENTO-5'],[8,'FILAMENTO-10']]},
    {"ids": [41369861423270, 44229490213030, 44229490278566, 57508935205030, 57508936220838, 57508936253606, 57508936286374, 57508936319142, 57508936351910, 57508936384678], "tiers": [[6, "RAFIA-6-3"], [12, "RAFIA-12-5"], [24, "RAFIA-24-10"]]},
    {ids:[44338788860070,44338818515110,44338827559078,44338832015526,44338835357862,42646250520742,41931097931942],tiers:[[5,'CINTAS-5-5'],[10,'CINTAS-10-10']],keepBoth:true},
    {"ids": [44797160718502, 44797160751270, 44797160784038, 44797160816806, 44797160849574, 44797160882342, 44797181034662, 44797181067430, 44797181100198, 44797181132966, 44797181165734, 44797181198502, 46018941747366, 46018958590118, 46018960031910, 44797189161126, 44797189193894, 44797189226662], "tiers": [[3, "POF-3-5"], [5, "POF-5-8"]]},
    {ids:[45468175696038,45468175728806,45468185198758,45468185231526],tiers:[[3,'TAPETES-3-5'],[5,'TAPETES-5-7'],[10,'TAPETES-10-12']]},
    {id:46387568967846,tiers:[[3,'SOBRES-15X22-300'],[5,'SOBRES-15X22-500'],[10,'SOBRES-15X22-1000']]},
    {id:46392691589286,tiers:[[3,'SOBRES-17X25-300'],[5,'SOBRES-17X25-500'],[10,'SOBRES-17X25-1000']]},
    {id:44969935044774,tiers:[[5,'BARRA-5-PZ'],[10,'BARRA-10-PZ']]},
    {ids:[57415301202086,57415301398694],tiers:[[2,'SILICA-200-2'],[5,'SILICA-500-5'],[10,'SILICA-1000-10'],[20,'SILICA-2000-15']]},
    {ids:[56099172450470,56099172516006,56099172581542,56099172647078,56099450093734,56099450159270,56099450224806,56099450290342,46491693613222,46491693678758,46491693744294,46491693809830,46491674378406,46491674443942,46491674509478,46491674575014,46491665334438,46491665399974,46491665465510,46491665531046],tiers:[[5,'SELLOS-500-5'],[10,'SELLOS-1000-7'],[50,'SELLOS-5000-12']]}
  ];
  const colorPairs=[[46107250852006, 57608065384614], [46107250786470, 57608065417382], [46107250819238, 57608065450150], [46109144580262, 57608065482918], [46107250884774, 57608065515686], [46107250917542, 57608065548454]];
  const colorTiers=[[3,'COLORES-3-3'],[5,'COLORES-5-5'],[10,'COLORES-10-8']];
  rules.push({ids:colorPairs.map(p=>p[1]),tiers:colorTiers});
  function validateColores(cart){
    if(colorPairs.some(pair=>stretchIssue(cart.items,pair[0])))throw new Error('Stretch de colores: elige hasta 3 rollos sueltos o paquetes completos de 4 por color. Ajusta las cantidades del carrito.');
  }
  function validateColoresDiscount(cart){
    const required=wanted(cart).filter(code=>code.startsWith('COLORES-'));
    if(required.some(code=>!cart.discount_codes?.some(d=>d.code.toUpperCase()===code&&d.applicable)))throw new Error('No se pudo confirmar el descuento de colores. Revisa los cupones del carrito antes de pagar.');
  }
  const preestiradaIds=[34545341857958,42738864881830];
  if(config.preestiradaEnabled)rules.push({ids:preestiradaIds,tiers:[[3,'PREESTIRADA-3-3'],[5,'PREESTIRADA-5-5'],[10,'PREESTIRADA-10-8']]});
  function validatePreestirada(cart){
    const applicators=cart.items.filter(i=>Number(i.product_id)===15860151386278).reduce((n,i)=>n+i.quantity,0);
    if(applicators>5)throw new Error(config.applicatorLimit);
  }
  function validatePreestiradaDiscount(cart){
    if(!config.preestiradaEnabled)return;
    const required=wanted(cart).filter(code=>code.startsWith('PREESTIRADA-'));
    if(required.some(code=>!cart.discount_codes?.some(d=>d.code.toUpperCase()===code&&d.applicable)))throw new Error(config.preestiradaError);
  }
  const miniEnabled=true;
  const miniIds=[44279261167782,44811013193894,57609431777446];
  const miniCodes=['MINI-16-3','MINI-32-5','MINI-64-8'];
  if(miniEnabled)rules.push({ids:miniIds,tiers:[[8,miniCodes[0]],[16,miniCodes[1]],[32,miniCodes[2]]],keepBoth:true});
  function validateMini(cart){
    if(!miniEnabled)return;
    const count=cart.items.filter(i=>miniIds.includes(Number(i.variant_id))).reduce((n,i)=>n+i.quantity,0);
    const index=count>=32?2:count>=16?1:count>=8?0:-1;
    if(index>=0&&!cart.discount_codes?.some(d=>d.code.toUpperCase()===miniCodes[index]&&d.applicable))throw new Error('No se pudo confirmar el descuento de mini rollos. Revisa el carrito antes de pagar.');
  }
  function validateTarima(cart){
    const required=wanted(cart).filter(code=>code.startsWith('TARIMA-ONEWAY-'));
    if(required.some(code=>!cart.discount_codes?.some(d=>d.code.toUpperCase()===code&&d.applicable)))throw new Error(config.tarimaError);
  }
  const hasBopp=cart=>cart.items.some(item=>boppIds.includes(Number(item.variant_id)));
  function validateBopp(cart){
    const count=cart.items.filter(item=>boppIds.includes(Number(item.variant_id))).reduce((n,item)=>n+item.quantity,0);
    const expected=[...boppTiers].reverse().find(tier=>count>=tier[0])?.[1];
    if(expected&&!cart.discount_codes?.some(d=>d.code.toUpperCase()===expected&&d.applicable))throw new Error(config.boppError);
  }
  const retiredBoppCodes=["BOPP-CANTIDAD2", "BOPP-CANTIDAD3", "BOPP-CANTIDAD4", "BOPP-CANTIDAD5", "BOPP-CANTIDAD6", "BOPP-CANTIDAD7", "BOPP-CANTIDAD8", "BOPP-CANTIDAD9", "BOPP-CANTIDAD10", "BOPP-CANTIDAD11", "BOPP-CANTIDAD12", "BOPP-CANTIDAD13", "BOPP-CANTIDAD14", "BOPP-CANTIDAD15", "BOPP-CANTIDAD16", "BOPP-CANTIDAD17", "BOPP-CANTIDAD18", "BOPP-CANTIDAD19", "BOPP-VOLUMEN20", "BOPP-CANTIDAD21", "BOPP-CANTIDAD22", "BOPP-CANTIDAD23", "BOPP-CANTIDAD24", "BOPP-CANTIDAD25", "BOPP-CANTIDAD26", "BOPP-CANTIDAD27", "BOPP-CANTIDAD28", "BOPP-CANTIDAD29", "BOPP-CANTIDAD30", "BOPP-CANTIDAD31", "BOPP-CANTIDAD32", "BOPP-CANTIDAD33", "BOPP-CANTIDAD34", "BOPP-CANTIDAD35", "BOPP-CANTIDAD36", "BOPP-CANTIDAD37", "BOPP-CANTIDAD38", "BOPP-CANTIDAD39", "BOPP-VOLUMEN40"];
  const owned=new Set([...retiredBoppCodes,'BOPP-20P-5','BOPP-40P-10','FLEJES-PP-3','FLEJES-PP-5','FLEJES-PP-8','FLEJES-PET-3','FLEJES-PET-5','FLEJES-PET-8',...rules.flatMap(r=>r.tiers.map(t=>t[1])),'PERRO-450-10','PERRO-450-15','PERRO-450-25','PERRO-1350-10','PERRO-1350-20','RAFIA-24-8','FILAMENTO-24-3','FILAMENTO-24-5','FILAMENTO-24-10','FILAMENTO-48-3','FILAMENTO-48-5','FILAMENTO-48-10']);
  const hasEnvelopes=cart=>cart.items.some(i=>rules.some(r=>(r.ids||[r.id]).includes(Number(i.variant_id))));
  const existing=cart=>(cart.discount_codes||[]).map(d=>d.code.toUpperCase());
  const wanted=cart=>rules.map(rule=>{
    const quantity=cart.items.filter(i=>(rule.ids||[rule.id]).includes(Number(i.variant_id))).reduce((sum,i)=>sum+i.quantity,0);
    return rule.keepBoth?(quantity>=(rule.minimumApply||1)?rule.tiers.map(t=>t[1]):[]):[...rule.tiers].reverse().find(t=>quantity>=t[0])?.[1];
  }).flat().filter(Boolean);
  async function request(path,body){
    const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),15000);
    try{
      const response=await fetch(root+path,{method:body?'POST':'GET',headers:{Accept:'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{cache:'no-store'}),signal:controller.signal});
      if(!response.ok)throw new Error(config.error);
      const cart=await response.json();if(!Array.isArray(cart.items))throw new Error(config.error);return cart;
    }finally{clearTimeout(timer);}
  }
  const sections=()=>[
    {id:'main-cart-items',section:document.getElementById('main-cart-items')?.dataset.id,selector:'.js-contents'},
    {id:'main-cart-footer',section:document.getElementById('main-cart-footer')?.dataset.id,selector:'.js-contents'},
    {id:'cart-icon-bubble',section:'cart-icon-bubble',selector:'.shopify-section'},
    {id:'cart-live-region-text',section:'cart-live-region-text',selector:'.shopify-section'}
  ].filter(s=>s.section&&document.getElementById(s.id));
  function render(cart){
    document.dispatchEvent(new CustomEvent('packsys:filamento-cart',{detail:{cart}}));
    sections().forEach(s=>{
      const html=cart.sections?.[s.section];if(!html)return;
      const parsed=new DOMParser().parseFromString(html,'text/html').querySelector(s.selector);
      const parent=document.getElementById(s.id),target=parent?.querySelector(s.selector)||parent;
      if(parsed&&target)target.innerHTML=parsed.innerHTML;
    });
    document.querySelectorAll('[data-sobres-express]').forEach(el=>{el.hidden=hasEnvelopes(cart)||hasFilamento(cart);});
  }
  async function synchronize(cart,options={}){
    const refreshSections=Boolean(cart?.sections)||options.refreshSections;
    cart=await request('cart.js');
    const traditionalPairs=[[41510827851942,57585240539302],[41510827884710,57585240572070]];
    const regroup={};
    for(const [roll,pallet] of traditionalPairs){
      const singles=cart.items.filter(i=>Number(i.variant_id)===roll&&!i.selling_plan_allocation&&Object.keys(i.properties||{}).length===0);
      const count=singles.reduce((n,i)=>n+i.quantity,0),complete=Math.floor(count/50);
      if(!complete)continue;
      const palletLines=cart.items.filter(i=>Number(i.variant_id)===pallet&&!i.selling_plan_allocation&&Object.keys(i.properties||{}).length===0);
      let toRemove=complete*50;
      singles.forEach(i=>{const remove=Math.min(toRemove,i.quantity);if(remove){regroup[i.key]=i.quantity-remove;toRemove-=remove;}});
      if(palletLines.length)regroup[palletLines[0].key]=palletLines[0].quantity+complete;else regroup[String(pallet)]=complete;
    }
    if(Object.keys(regroup).length)cart=await request('cart/update.js',{updates:regroup,sections:options.sections||sections().map(s=>s.section),sections_url:window.location.pathname});
    const current=existing(cart),selected=wanted(cart),codes=[...new Set([...current.filter(c=>!owned.has(c)),...selected])];
    if(codes.length>5&&selected.length)throw new Error(config.limit);
    const changed=Object.keys(regroup).length>0||[...current].sort().join(',')!==[...codes].sort().join(',');
    if(changed||refreshSections){
      const sectionIds=options.sections||sections().map(s=>s.section);
      cart=await request('cart/update.js',{discount:codes.join(','),...(sectionIds.length?{sections:sectionIds,sections_url:window.location.pathname}:{})});
    }
    document.querySelectorAll('[data-sobres-express]').forEach(el=>{el.hidden=hasEnvelopes(cart)||hasFilamento(cart);});
    document.dispatchEvent(new CustomEvent('packsys:bopp-cart',{detail:{cart}}));
    document.dispatchEvent(new CustomEvent('packsys:cart-synchronized',{detail:{cart}}));
    return {cart,changed};
  }
  let queue=Promise.resolve();
  const ensure=(cart,options)=>{queue=queue.catch(()=>{}).then(()=>synchronize(cart,options));return queue;};
  window.PacksysSobresDiscounts={stretchRule,stretchIssue,validateManualDiscount,validateTarima,validateBopp,ensure,request,render,hasEnvelopes,validateFilamento,validateManual,validatePreestirada,validatePreestiradaDiscount,validateColores,validateColoresDiscount,validateMini};
  document.dispatchEvent(new CustomEvent('packsys:quantity-rules-ready'));
  function showError(error){
    let el=document.getElementById('cart-errors');
    if(!el)el=document.getElementById('PacksysSobresDiscountError');
    if(!el){el=document.createElement('p');el.id='PacksysSobresDiscountError';el.setAttribute('role','alert');el.className='ps-sobres-discount-error';document.body.append(el);}
    el.textContent=error.message||config.error;
  }
  function validateManualDiscount(cart){
    const required=wanted(cart).filter(code=>code.startsWith('MANUAL-'));
    if(required.some(code=>!cart.discount_codes?.some(d=>d.code.toUpperCase()===code&&d.applicable)))throw new Error(config.manualDiscountError);
  }
  let checking=false;
  async function prepareCheckout(){
    const cartItems=document.querySelector('cart-items');
    if(cartItems?.flushPendingUpdates)await cartItems.flushPendingUpdates();
    else{await new Promise(resolve=>setTimeout(resolve,350));await cartItems?.pendingUpdate;}
    window.PacksysCartQuantities?.assert();
    await window.PacksysPurchaseOrderController?.save();
    const {cart}=await ensure();render(cart);validateFilamento(cart);validateManual(cart);validatePreestirada(cart);validatePreestiradaDiscount(cart);validateColores(cart);validateColoresDiscount(cart);validateMini(cart);validateBopp(cart);validateTarima(cart);
    validateManualDiscount(cart);
    return cart;
  }
  // The cart's other checkout handlers can navigate on click before submit.
  // Capture applicator carts first, then reuse the same stock/discount checks.
  window.addEventListener('click',event=>{
    const button=event.target.closest('button[name="checkout"],input[name="checkout"]');
    if(!button)return;
    event.preventDefault();event.stopImmediatePropagation();
    if(checking)return;checking=true;button.disabled=true;
    prepareCheckout().then(cart=>{
      location.assign(root+'checkout?discount='+encodeURIComponent(existing(cart).join(',')));
    }).catch(error=>{checking=false;button.disabled=false;showError(error);});
  },true);
  document.addEventListener('submit',event=>{
    const form=event.target,submitter=event.submitter;
    if(submitter?.name!=='checkout'&&form.id!=='cart-notification-form')return;
    if(form.dataset.sobresVerified==='true'){delete form.dataset.sobresVerified;return;}
    event.preventDefault();event.stopImmediatePropagation();if(checking)return;checking=true;
    if(submitter)submitter.disabled=true;
    prepareCheckout().then(cart=>{
      const cintas=cart.items.some(i=>[44338788860070,44338818515110,44338827559078,44338832015526,44338835357862,42646250520742,41931097931942].includes(Number(i.variant_id)));if(hasBopp(cart)||cintas||(miniEnabled&&cart.items.some(i=>miniIds.includes(Number(i.variant_id))))){location.assign(root+'checkout?discount='+encodeURIComponent(existing(cart).join(',')));return;}
      checking=false;if(submitter)submitter.disabled=false;
      form.dataset.sobresVerified='true';form.requestSubmit(submitter||undefined);
    }).catch(error=>{checking=false;if(submitter)submitter.disabled=false;showError(error);});
  },true);
  document.addEventListener('click',event=>{
    const link=event.target.closest('a[href]');if(!link)return;
    const url=new URL(link.href,location.origin);if(url.origin!==location.origin||!/(^|\/)checkout\/?$/.test(url.pathname))return;
    event.preventDefault();event.stopImmediatePropagation();if(checking)return;checking=true;
    prepareCheckout().then(cart=>{if(hasBopp(cart)||(miniEnabled&&cart.items.some(i=>miniIds.includes(Number(i.variant_id))))||cart.items.some(i=>[44338788860070,44338818515110,44338827559078,44338832015526,44338835357862,42646250520742,41931097931942].includes(Number(i.variant_id))))url.searchParams.set('discount',existing(cart).join(','));location.assign(url.href);}).catch(error=>{checking=false;showError(error);});
  },true);
  const initialize=(restored=false)=>{
    if(!document.getElementById('main-cart-items'))return;
    const checkout=document.getElementById('checkout'),wasDisabled=restored?false:checkout?.disabled;
    if(checkout)checkout.disabled=true;
    ensure(undefined,{refreshSections:restored}).then(({cart,changed})=>{if(changed||restored)render(cart);if(checkout)checkout.disabled=Boolean(wasDisabled)||cart.item_count===0;}).catch(error=>{if(checkout)checkout.disabled=Boolean(wasDisabled);showError(error);});
  };
  window.addEventListener('pageshow',event=>{if(event.persisted){checking=false;initialize(true);}});
  document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible'&&!checking)initialize(true);});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize(),{once:true});else initialize();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["packsys-sobres-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('packsys-sobres-summary')) {
    customElements.define('packsys-sobres-summary', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('.shopify-section');
        this.variants = JSON.parse(this.querySelector('script').textContent);
        this.update = this.render.bind(this);
        this.root.addEventListener('change', this.update);
        this.root.addEventListener('input', this.update);
        this.render();
      }
      disconnectedCallback() {
        this.root.removeEventListener('change', this.update);
        this.root.removeEventListener('input', this.update);
      }
      render() {
        const picker = this.root.querySelector('variant-radios, variant-selects');
        const options = picker ? Array.from(picker.querySelectorAll('input:checked, select')).map(el => el.value) : [];
        const variant = this.variants.find(v => v.options.every((value, index) => value === options[index]));
        const quantity = Number(this.root.querySelector('input[name="quantity"]')?.value);
        if (!variant || !Number.isInteger(quantity) || quantity < 1) return;
        const pieces = Number.parseInt(variant.option2, 10);
        if (!pieces) return;
        const currency = this.dataset.currency || 'MXN';
        const language = this.dataset.locale || 'es';
        const locale = language === 'es' ? 'es-MX' : language;
        const money = new Intl.NumberFormat(locale, {style:'currency', currency});
        const unit = new Intl.NumberFormat(locale, {style:'currency', currency, minimumFractionDigits:3, maximumFractionDigits:3});
        this.querySelector('[data-summary-output]').textContent = this.dataset.summary.replace('__PACKS__', quantity).replace('__PIECES__', pieces).replace('__TOTAL__', quantity * pieces);
        this.querySelector('[data-total-output]').textContent = this.dataset.total.replace('__AMOUNT__', money.format(variant.price * quantity / 100));
        this.querySelector('[data-unit-output]').textContent = this.dataset.unit.replace('__AMOUNT__', unit.format(variant.price / 100 / pieces));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["packsys-sobres-volume-preview"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('packsys-sobres-volume-preview')) return;
    const schedules = {'15 x 22 cm':[[300,600],[500,1400],[1000,2600]],'17 x 25 cm':[[300,850],[500,950],[1000,2350]]};
    const normalize = value => Math.min(100000,Math.max(100,Math.ceil((Number(value)||100)/100)*100));
    customElements.define('packsys-sobres-volume-preview',class extends HTMLElement {
      connectedCallback(){
        if(this.initialized)return;
        this.initialized=true;
        this.config=JSON.parse(this.querySelector('[data-config]').textContent);
        this.size=this.config.selectedSize;this.quantity=100;
        this.enabled=this.config.enabled===true;
        this.root=this.config.root.replace(/\/?$/,'/');
        this.cart={items:this.config.cartItems,currency:this.config.currency};this.cartReady=!this.enabled;this.busy=false;this.error='';
        this.money=new Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'});
        this.unitMoney=new Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN',minimumFractionDigits:3,maximumFractionDigits:3});
        this.number=new Intl.NumberFormat('es-MX');
        this.addEventListener('click',event=>{
          const button=event.target.closest('button');if(!button||this.busy)return;
          if(button.hasAttribute('data-add')){this.add();return;}
          if(button.dataset.size)this.size=button.dataset.size;
          if(button.dataset.step)this.quantity=normalize((Number(this.querySelector('[data-quantity]').value)||100)+Number(button.dataset.step));
          if(button.dataset.preset)this.quantity=Number(button.dataset.preset);
          this.querySelector('[data-normalized]').hidden=true;this.render();
        });
        const input=this.querySelector('[data-quantity]');
        const commit=()=>{
          const raw=Number(input.value);if(raw===this.quantity)return;
          this.quantity=normalize(raw);
          const note=this.querySelector('[data-normalized]');note.hidden=raw===this.quantity;
          note.textContent=this.text('normalized',{quantity:this.number.format(this.quantity)});this.render();
        };
        input.addEventListener('input',()=>{
          const raw=Number(input.value);
          if(Number.isInteger(raw)&&raw>=100&&raw<=100000&&raw%100===0){this.quantity=raw;this.querySelector('[data-normalized]').hidden=true;this.render();}
        });
        input.addEventListener('change',commit);input.addEventListener('blur',commit);
        input.addEventListener('keydown',event=>{if(event.key==='Enter'){event.preventDefault();commit();}});
        this.render();
        if(this.enabled)this.refreshCart().then(()=>this.render()).catch(()=>{this.error=this.text('cart_error');this.render();});
      }
      text(key,args={}){return Object.entries(args).reduce((s,[k,v])=>s.replaceAll('{'+k+'}',String(v)),this.config.strings[key]||key);}
      tier(q){return [...(schedules[this.size]||[])].reverse().find(t=>q>=t[0])||[100,0];}
      base(){return this.config.variants.find(v=>v.size===this.size&&v.pack===100);}
      cartLines(){return this.cart.items.filter(item=>Number(item.variant_id)===this.base()?.id);}
      inCart(){return this.cartLines().reduce((sum,item)=>sum+item.quantity*100,0);}
      quote(){
        const base=this.base();if(!base)return null;
        const combined=this.quantity+this.inCart(),tier=this.tier(combined),before=base.price*(combined/100);
        const hundredPrice=Math.floor((base.price*(10000-tier[1])+5000)/10000);
        const total=hundredPrice*(combined/100);
        return {base,combined,tier,before,total,stockOk:base.available&&(!base.tracked||combined<=base.stock*100)};
      }
      async json(path,body){
        const controller=new AbortController(),timeout=setTimeout(()=>controller.abort(),15000);
        try{
          const response=await fetch(this.root+path,{method:body?'POST':'GET',headers:{Accept:'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{cache:'no-store'}),signal:controller.signal});
          const data=await response.json();
          if(!response.ok||data.status)throw new Error(data.description||data.message||this.text('cart_error'));
          return data;
        }finally{clearTimeout(timeout);}
      }
      async refreshCart(){
        const cart=await this.json('cart.js');
        if(!Array.isArray(cart.items))throw new Error(this.text('cart_error'));
        this.cart=cart;this.cartReady=true;
      }
      render(){
        const quote=this.quote();if(!quote){this.showError(this.text('configuration_error'));return;}
        const {base,combined,tier,before,total,stockOk}=quote,count=this.inCart();
        this.orderSelection={id:base.id,quantity:this.quantity/100};
        this.querySelector('[data-quantity]').value=this.quantity;
        this.querySelector('[data-quantity]').disabled=this.busy;
        this.querySelector('[data-step="-100"]').disabled=this.busy||this.quantity===100;
        this.querySelector('[data-step="100"]').disabled=this.busy||this.quantity===100000;
        this.querySelectorAll('[data-size]').forEach(b=>{b.setAttribute('aria-pressed',String(b.dataset.size===this.size));b.disabled=this.busy;});
        this.querySelector('[data-cart-count]').hidden=!count;
        this.querySelector('[data-cart-count]').textContent=this.text('cart_count',{quantity:this.number.format(count),adding:this.number.format(this.quantity),combined:this.number.format(combined)});
        this.querySelector('[data-current]').textContent=this.text(this.enabled?'current_live':'current',{quantity:this.number.format(combined),percent:tier[1]/100});
        this.querySelectorAll('[data-preset]').forEach(b=>{
          const q=Number(b.dataset.preset),rate=this.tier(q+count)[1]/100;
          const currentPreset=[100,300,500,1000,2000,5000].find(p=>this.tier(p+count)[1]===tier[1]);
          const isCurrent=q===currentPreset;
          b.setAttribute('aria-pressed',String(q===this.quantity));b.dataset.currentTier=String(isCurrent);b.disabled=this.busy;
          if(isCurrent)b.setAttribute('aria-current','step');else b.removeAttribute('aria-current');
          b.querySelector('.ps-volume__tier-current').hidden=!isCurrent;
          const badge=b.querySelector('.ps-volume__badge');badge.hidden=!rate;badge.textContent=this.text('save',{percent:rate});
        });
        const next=schedules[this.size].find(t=>t[0]>combined);
        this.querySelector('[data-next]').textContent=next?this.text('next',{quantity:this.number.format(next[0]-combined),percent:next[1]/100}):this.text('maximum');
        this.querySelector('[data-progress-fill]').style.width=Math.min(100,combined/1000*100)+'%';
        this.querySelector('[data-progress]').setAttribute('aria-valuenow',String(Math.min(1000,combined)));
        this.querySelector('[data-progress]').setAttribute('aria-valuetext',this.querySelector('[data-current]').textContent);
        this.querySelector('[data-hundreds]').textContent=this.text('hundreds',{count:this.number.format(combined/100),quantity:this.number.format(combined)});
        this.querySelector('[data-total-bags]').textContent=this.text('pieces',{quantity:this.number.format(combined)});
        this.querySelector('[data-total]').textContent=this.money.format(total/100)+' MXN';
        this.querySelector('[data-unit]').textContent=this.text('unit',{price:this.unitMoney.format(total/100/combined)});
        this.querySelector('[data-saving]').hidden=false;this.querySelector('[data-saving]').textContent=this.text('saving',{price:this.money.format((before-total)/100),percent:tier[1]/100});
        const stock=this.querySelector('[data-stock]');stock.hidden=stockOk;
        stock.textContent=this.text(this.enabled?'stock_live':'stock',{quantity:this.number.format(Math.max(0,base.stock*100-count))});
        const add=this.querySelector('[data-add]');
        if(add){add.disabled=!this.enabled||this.busy||!this.cartReady||!stockOk||this.cart.currency!=='MXN'||this.addUncertain;add.textContent=this.busy?this.text('adding'):this.text('add');}
        this.setAttribute('aria-busy',String(this.busy));
        this.showError(this.cart.currency!=='MXN'?this.text('currency_error'):this.error);
      }
      showError(message){const el=this.querySelector('[data-error]');el.textContent=message;el.hidden=!message;}
      async add(){
        if(!this.enabled||this.busy||!this.cartReady||this.addUncertain||!this.querySelector('[data-add]'))return;
        this.quantity=normalize(this.querySelector('[data-quantity]').value);
        this.busy=true;this.error='';this.render();let sent=false;
        try{
          await this.refreshCart();
          const quote=this.quote();
          if(!quote||!quote.stockOk)throw new Error(this.text('stock_live',{quantity:this.number.format(Math.max(0,(quote?.base.stock||0)*100-this.inCart()))}));
          if(this.cart.currency!=='MXN')throw new Error(this.text('currency_error'));
          const added=this.quantity;
          sent=true;
          await this.json('cart/add.js',{items:[{id:quote.base.id,quantity:added/100}]});
          this.cart=(await window.PacksysSobresDiscounts.ensure()).cart;
          const lines=this.cartLines(),actual=lines.reduce((sum,line)=>sum+line.final_line_price,0);
          if(this.inCart()!==quote.combined||actual>quote.total+1)throw new Error(this.text('discount_mismatch'));
          const status=this.querySelector('[data-status]');status.hidden=false;status.textContent=this.text('added',{quantity:this.number.format(added)});
          window.location.assign(this.root+'cart');
        }catch(error){
          this.error=(error.message||this.text('cart_error'))+(sent?' '+this.text('add_error'):'');
          this.addUncertain=sent;
          this.querySelector('[data-cart-link]').hidden=!sent;
          this.busy=false;this.render();
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
